<template>
  <div class="min-h-screen bg-gradient-to-br from-[#f5f5f5] to-[#e9ecef] flex items-center py-12">
    <div class="max-w-[700px] mx-auto px-6 w-full text-center">

      <!-- 404 number -->
      <div class="text-[9rem] font-black leading-none mb-4 bg-gradient-to-r from-[#FFD500] to-[#FFC107] bg-clip-text text-transparent select-none">
        404
      </div>

      <h1 class="text-[2rem] font-extrabold text-[#111] mb-3">Pagina niet gevonden</h1>
      <p class="text-[1.05rem] text-[#666] mb-10 leading-relaxed">
        De pagina die je zoekt bestaat niet of is verplaatst.<br>
        Gebruik de navigatie hieronder om verder te gaan.
      </p>

      <!-- CTAs -->
      <div class="flex gap-3 justify-center flex-wrap mb-12">
        <router-link
          to="/"
          class="inline-flex items-center gap-2 bg-[#FFD500] hover:bg-[#ffb800] text-[#111] font-bold px-7 py-3.5 rounded-xl no-underline transition-all hover:-translate-y-[1px] hover:shadow-lg hover:shadow-[#FFD500]/30"
        >
          <i class="bi bi-house"></i>
          Terug naar home
        </router-link>
        <router-link
          to="/producten"
          class="inline-flex items-center gap-2 bg-white hover:border-[#FFD500] border-2 border-[#e9ecef] text-[#333] font-bold px-7 py-3.5 rounded-xl no-underline transition-all"
        >
          <i class="bi bi-grid"></i>
          Bekijk producten
        </router-link>
      </div>

      <!-- Quick links -->
      <div class="bg-white rounded-2xl border border-[#e9eaec] p-6 mb-6">
        <h3 class="text-[1.1rem] font-bold text-[#111] mb-5">Populaire pagina's</h3>
        <div class="grid grid-cols-2 gap-3">
          <router-link
            v-for="link in quickLinks"
            :key="link.to"
            :to="link.to"
            class="flex items-center gap-3 bg-[#f8f9fa] hover:bg-[#fffbeb] hover:border-[#FFD500] border-2 border-transparent px-4 py-3.5 rounded-xl no-underline text-[#333] font-semibold text-[0.9rem] transition-all hover:translate-x-[4px]"
          >
            <i :class="['bi text-[1.2rem] text-[#FFD500]', link.icon]"></i>
            {{ link.label }}
          </router-link>
        </div>
      </div>

      <!-- Help -->
      <div class="bg-[#f8f9fa] border border-[#e9eaec] rounded-2xl p-5 flex items-start gap-4 text-left">
        <i class="bi bi-headset text-[2.5rem] text-[#FFD500] shrink-0"></i>
        <div>
          <strong class="block text-[1rem] font-bold text-[#111] mb-1">Hulp nodig?</strong>
          <p class="text-[0.875rem] text-[#666] mb-3">Onze experts helpen je graag verder</p>
          <a
            href="mailto:info@plug2charge.nl"
            class="inline-flex items-center gap-2 text-[0.875rem] font-bold text-[#FFD500] hover:text-[#ffb800] no-underline transition-colors"
          >
            <i class="bi bi-envelope"></i>
            info@plug2charge.nl
          </a>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

const quickLinks = [
  { to: '/categorie/zonnepanelen',  icon: 'bi-sun',       label: 'Zonnepanelen' },
  { to: '/categorie/laadpalen',     icon: 'bi-lightning-charge',      label: 'Laadpalen' },
  { to: '/categorie/complete-sets', icon: 'bi-box-seam',   label: 'Complete Sets' },
  { to: '/merken',                  icon: 'bi-tag',       label: 'Merken' },
]

onMounted(() => {
  document.title = 'Pagina niet gevonden | Plug2Charge.nl'
})
</script>
